import _ from 'lodash';

export const getErrorMessage = (errors, touched, attributePath, initialized) =>
  (initialized || _.get(touched, attributePath)) && _.get(errors, attributePath);
export const getErrorClass = (errors, touched, attributePath, initialized) =>
  (initialized || _.get(touched, attributePath)) && _.get(errors, attributePath) ? 'erroredInput' : '';
